import React from 'react';
import TestimonialsCarousel from '../../TestimonialsCarousel';
import { motion } from 'framer-motion';

/**
 * Componente ProblemSection
 * 
 * Agora exibe os testemunhos/carrossel de clientes.
 * Organizada de forma modular com componentes separados para cada parte.
 * 
 * Chamado por: App ou layout principal
 * Chama: TestimonialsCarousel, ComparisonSection, SectionCTA
 * Complexidade: O(1) - renderização estática
 */

const TestimonialsHeader: React.FC = () => (
  <>
    <motion.h2
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7 }}
      className="text-4xl md:text-5xl font-bold text-center mb-4 text-white"
    >
      O QUE NOSSOS CLIENTES DIZEM
    </motion.h2>
    <motion.h3
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.7, delay: 0.3 }}
      className="text-2xl md:text-3xl font-bold text-center mb-4 md:mb-6 text-yellow-400 glow-headline"
    >
      Depoimentos reais de quem já economiza com a RTL
    </motion.h3>
  </>
);

const ProblemSection: React.FC = () => {
  return (
    <section id="problema" className="pt-12 md:pt-16 pb-12 md:pb-16 bg-blue-900 text-white" style={{ backgroundColor: '#003366' }}>
      <div className="container mx-auto px-6 lg:px-8">
        <TestimonialsHeader />
        <TestimonialsCarousel />
      </div>
    </section>
  );
};

export default ProblemSection; 